<div class="container-fluid">
    <div class="row">
        <app-speed-dial-fab (clicked)="dispatch($event)" [options]="FabOptions"></app-speed-dial-fab>
        <div class="col-12 col-xl-6 my-1">
            <div class="border rounded-1 background-light p-3">
                <!-- <h5 class="card-header">Localisation</h5> -->
                <div class="row">
                    <h2 class="col text-center fw-bold"> Localisation</h2>
                </div>
                <div class="row">
                    <div class="col">
                        <div class="row text-center">
                            <div class="col fw-bold">
                                Amont
                            </div>
                        </div>
                        <div class="row">
                            <mat-form-field class="col">
                                <mat-label>X</mat-label>
                                <input matInput placeholder="X" type="number" [(ngModel)]="IBMRProcess.LocalisationStation.Amont.L93X"
                                       [formControl]="IsAmontX2FarControl"
                                       (keyup)="onAmontXKeyUpEvent($event)">
                                <mat-error *ngIf="IsAmontX2FarControl.hasError('pattern')">
                                    Format erroné. 6 chiffres uniquement !
                                </mat-error>
                                <mat-error *ngIf="!IsAmontX2FarControl.valid && !IsAmontX2FarControl.hasError('pattern')">
                                    Ecart > 500
                                </mat-error>
                            </mat-form-field>
                            <mat-form-field class="col">
                                <mat-label>Y</mat-label>
                                <input matInput placeholder="Y" type="number" [(ngModel)]="IBMRProcess.LocalisationStation.Amont.L93Y"
                                       [formControl]="IsAmontY2FarControl"
                                       (keyup)="onAmontYKeyUpEvent($event)">
                                <mat-error *ngIf="IsAmontY2FarControl.hasError('pattern')">
                                    Format erroné. 7 chiffres uniquement !
                                </mat-error>
                                <mat-error *ngIf="!IsAmontY2FarControl.valid && !IsAmontY2FarControl.hasError('pattern')">
                                    Ecart > 500
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <div class="row text-center">
                            <div class="col fw-bold">
                                Aval
                            </div>
                        </div>
                        <div class="row">
                            <mat-form-field class="col">
                                <mat-label>X</mat-label>
                                <input matInput placeholder="X" type="number" [(ngModel)]="IBMRProcess.LocalisationStation.Aval.L93X"
                                       [formControl]="IsAvalX2FarControl"
                                       (keyup)="onAvalXKeyUpEvent($event)">
                                <mat-error *ngIf="IsAvalX2FarControl.hasError('pattern')">
                                    Format erroné. 6 chiffres uniquement !
                                </mat-error>
                                <mat-error *ngIf="!IsAvalX2FarControl.valid && !IsAvalX2FarControl.hasError('pattern')">
                                    Ecart > 500
                                </mat-error>
                            </mat-form-field>
                            <mat-form-field class="col">
                                <mat-label>Y</mat-label>
                                <input matInput placeholder="Y" type="number" [(ngModel)]="IBMRProcess.LocalisationStation.Aval.L93Y"
                                       [formControl]="IsAvalY2FarControl"
                                       (keyup)="onAvalYKeyUpEvent($event)">
                                <mat-error *ngIf="IsAvalY2FarControl.hasError('pattern')">
                                    Format erroné. 7 chiffres uniquement !
                                </mat-error>
                                <mat-error *ngIf="!IsAvalY2FarControl.valid && !IsAvalY2FarControl.hasError('pattern')">
                                    Ecart > 500
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="row text-center">
                        <div class="col fw-bold">
                            Commentaire
                        </div>
                    </div>

                    <div class="row">
                        <mat-form-field class="col">
                            <mat-label>Limite Amont</mat-label>
                            <input matInput placeholder="Limite Amont" [(ngModel)]="IBMRProcess.LocalisationStation.LimiteAmont"
                                   [formControl]="ValidAmontMaxLength">
                            <mat-hint align="end">{{IBMRProcess.LocalisationStation.LimiteAmont?.length || 0}}/{{COMMENT_MAX_SIZE}}</mat-hint>
                            <mat-error *ngIf="ValidAmontMaxLength.hasError('maxlength')">
                                Texte trop long
                            </mat-error>
                        </mat-form-field>
                        <mat-form-field class="col">
                            <mat-label>Limite Aval</mat-label>
                            <input matInput placeholder="Limite Aval" [(ngModel)]="IBMRProcess.LocalisationStation.LimiteAval"
                                   [formControl]="ValidAvalMaxLength">
                            <mat-hint align="end">{{IBMRProcess.LocalisationStation.LimiteAval?.length || 0}}/{{COMMENT_MAX_SIZE}}</mat-hint>
                            <mat-error *ngIf="ValidAvalMaxLength.hasError('maxlength')">
                                Texte trop long
                            </mat-error>
                        </mat-form-field>
                    </div>
                </div>

            </div>
        </div>

        <div class="col-12 col-xl-6 my-1">
            <div class="border rounded-1 background-light p-3">
                <!-- <h5 class="card-header">Mesure station</h5> -->
                <div class="row">
                    <h2 class="col text-center fw-bold">Mesure station</h2>
                </div>
                <div class="row align-items-center">
                    <div class="col-6">
                        <!-- <mat-form-field class="w-100">
                            <input matInput placeholder="" type="number" [(ngModel)]="IBMRProcess.IBMRMesureStation.Longueur">
                        </mat-form-field> -->
                        Longueur {{computeLongueurStation() | number: '1.1-1'}}
                    </div>
                    <!-- <div class="col-6">
                            <mat-form-field class="w-100">
                                <input matInput placeholder="Lm Moyenne" type="number" [(ngModel)]="IBMRProcess.IBMRMesureStation.LmMoyenne">
                            </mat-form-field>
                        </div> -->
                    <div class="col">
                        LpB moy {{computeLpBMoy() | number: '1.1-1'}}
                    </div>
                    <div class="col">
                        Lm moy {{computeLmMoy() | number: '1.1-1'}}
                    </div>
                    <div class="col">
                        Surface totale {{computeSurface() | number: '1.1-1'}}
                    </div>
                </div>
                <div class="row mt-3">
                    <h6 class="d-flex align-items-center m-0 col-auto">Largeur de la station</h6>

                    <button appPreventDoubleClick [throttleTime]="200" mat-icon-button color="primary" (throttledClick)="openMesureBox()">
                        <mat-icon>add</mat-icon>
                    </button>

                </div>
                <div class="row mt-3 justify-content-center">
                    <div *ngFor="let largueur of IBMRProcess.IBMRMesureStation.LargeurStations; let i = index" class="col-auto">
                        <div class="border rounded-pill p-3 py-5 m-1">

                            <div class="row justify-content-center">
                                <div class="col-10">
                                    <mat-form-field class="w-100">
                                        <mat-label>{{getLpB(i)}}</mat-label>
                                        <input matInput [placeholder]="getLpB(i)" type="number" [(ngModel)]="largueur.LpB" disabled="true">
                                    </mat-form-field>
                                </div>
                            </div>
                            <!-- <mat-form-field class="d-block m-auto ">
                                    <input matInput [placeholder]="getLm(i)" type="number" [(ngModel)]="largueur.Lm" disabled="true">
                                </mat-form-field> -->

                            <div class="p-0 d-flex justify-content-center">
                                <button appPreventDoubleClick [throttleTime]="200" mat-icon-button color="primary" (throttledClick)="openMesureBox(largueur)">
                                    <mat-icon>edit</mat-icon>
                                </button>
                                <button appPreventDoubleClick [throttleTime]="200" mat-icon-button color="primary" (throttledClick)="removeLargeur(largueur)">
                                    <mat-icon>delete</mat-icon>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-6">
                        <mat-form-field class="w-100">
                            <mat-label>Surface Totale</mat-label>
                            <input matInput placeholder="Surface Totale" type="number" [(ngModel)]="IBMRProcess.IBMRMesureStation.SurfaceTotale">
                        </mat-form-field>
                    </div>
                    <div class="col-6">
                        <mat-form-field class="w-100">
                            <mat-label>Mode Mesure</mat-label>
                            <mat-select placeholder="Mode Mesure" [(ngModel)]="IBMRProcess.IBMRMesureStation.ModeMesure" required>
                                <mat-option *ngFor="let p of ModeMesureList; let i = index" [value]="i + 1">
                                    <span>{{p}}</span>
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>
                <div class="row">
                    <div class="col-6">
                        <mat-form-field class="w-100">
                            <mat-label>Mode Estimation Recouvrement</mat-label>
                            <mat-select placeholder="Mode Estimation Recouvrement" [(ngModel)]="IBMRProcess.IBMRMesureStation.ModeEstimationRecouvrement">
                                <mat-option *ngFor="let p of ModeEstimationRecouvrementList; let i = index" [value]="i + 1">
                                    <span>{{p}}</span>
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <div class="col-6">
                        <mat-form-field class="w-100">
                            <mat-label>Mode Prelevement</mat-label>
                            <mat-select placeholder="Mode Prelevement" [(ngModel)]="IBMRProcess.IBMRMesureStation.ModePrelevement" required>
                                <mat-option *ngFor="let p of ModePrelevementList; let i = index" [value]="i + 1">
                                    <span>{{p}}</span>
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>

            </div>
        </div>

        <div class="col-12 my-1 ">
            <div class="display-5 text-center">
                Unite de releve 1
            </div>
        </div>

        <div class="col-12 col-xl-6 my-1">
            <div class="border rounded-1 background-light p-3">
                <!-- <h5 class="card-header">Unite de releve</h5> -->
                <div class="row">
                    <h2 class="col text-center fw-bold"> Unite de releve</h2>
                </div>
                <div class="row align-items-center">
                    <div class="col-6">
                        <mat-form-field class="w-100">
                            <mat-label>Longueur</mat-label>
                            <input matInput placeholder="Longueur" type="number" [ngModel]="computeLongueurForUR(IBMRProcess.IBMRUniteReleve1)" readonly>
                        </mat-form-field>
                    </div>
                    <div class="col-6">
                        Largeur {{computeLargeurForUR(IBMRProcess.IBMRUniteReleve1) | number:'1.2-2'}}
                    </div>
                </div>
                <div class="row mt-3">
                    <h6 class="d-flex align-items-center m-0 col-auto">Liste des transects</h6>

                    <button appPreventDoubleClick [throttleTime]="200" mat-icon-button color="primary" (throttledClick)="openMesureBoxForTransect(IBMRProcess.IBMRUniteReleve1)">
                        <mat-icon>add</mat-icon>
                    </button>

                </div>
                <div class="row mt-3 justify-content-center">
                    <div *ngFor="let largueur of IBMRProcess.IBMRUniteReleve1.IBMRTransectList; let i = index" class="col-auto text-center my-1">
                        <div class="row">

                            <div class="col"></div>
                            <div class="col align-content-center">
                                <h5>Transect {{i + 1}}</h5>
                            </div>

                            <div class="col p-0 d-flex justify-content-center">
                                <button appPreventDoubleClick [throttleTime]="200" mat-icon-button color="primary"
                                        (throttledClick)="openMesureBoxForTransect(IBMRProcess.IBMRUniteReleve1, largueur)">
                                    <mat-icon>edit</mat-icon>
                                </button>
                                <button appPreventDoubleClick [throttleTime]="200" mat-icon-button color="primary" (throttledClick)="removeTransect(largueur, IBMRProcess.IBMRUniteReleve1)">
                                    <mat-icon>delete</mat-icon>
                                </button>
                            </div>
                        </div>

                        <div class=" p-1 m-1 background-light">

                            <div class="row justify-content-center">
                                <div class="col-6">
                                    <mat-form-field class="w-100">
                                        <mat-label>{{getLongueur(i)}}</mat-label>
                                        <input matInput [placeholder]="getLongueur(i)" type="number" [(ngModel)]="largueur.LpB" disabled="true">
                                    </mat-form-field>
                                </div>

                                <div class="col-6">
                                    <mat-form-field class="w-100">
                                        <mat-label>{{getLm(i)}}</mat-label>
                                        <input matInput [placeholder]="getLm(i)" type="number" [(ngModel)]="largueur.Lm" disabled="true">
                                    </mat-form-field>
                                </div>

                            </div>

                        </div>

                        <div class="col-auto text-center my-1">
                            <div *ngFor="let taxon of largueur.TaxonList; let i = index" (click)="openTaxonIBMRBox(largueur, taxon)">
                                <div class="border rounded-1 p-1 m-1 " [class.background-orange]="taxon.Preleve" [class.background-violet-accent]="!taxon.Preleve">

                                    <div class="row justify-content-between">
                                        <div class="col-1">

                                        </div>
                                        <h3 class="col text-center" [matTooltip]="taxon.Comment" [matTooltipDisabled]="taxon.Comment !== undefined && taxon.Comment !== ''">
                                            {{taxon.Code}} 
                                            <h3 *ngIf="taxon.Preleve" class="text-center"> {{taxon.CustomName}}</h3>
                                        </h3>
                                        <div class="col-1">
                                            <button appPreventDoubleClick mat-icon-button color="primary" (throttledClick)="deleteTaxon(largueur, taxon)" class="icon-button-small">
                                                <mat-icon >clear</mat-icon>
                                            </button>
                                        </div>
                                    </div>

                                    <div *ngIf="taxon.Preleve" class="row mx-auto justify-content-center circle ">
                                        <div  class="text-center"> P{{taxon.NumeroPrelevement}}</div>
                                    </div>

                                    <div *ngIf="!taxon.Preleve" class="text-center"> {{taxon.NomOrdre}}</div>
                                    <div *ngIf="!taxon.Preleve" class="text-center"> {{taxon.NomFamille}}</div>
                                    <div *ngIf="!taxon.Preleve" class="text-center"> {{taxon.NomGenre}}</div>

                                    <div *ngIf="!taxon.Presence" class=" text-center fw-bold"> Quantité: {{taxon.Quantite}} {{getUnitName(taxon.Unit)}}</div>
                                    <div *ngIf="taxon.Presence" class=" text-center fw-bold"> Présence</div>

                                    <div class="text-center fst-italic"> {{taxon.Comment}}</div>
                                </div>

                            </div>
                        </div>
                        <button appPreventDoubleClick [throttleTime]="200" mat-raised-button color="accent" (throttledClick)="openTaxonIBMRBox(largueur)">
                            Ajouter un taxon
                        </button>
                        <div class="row my-3 justify-content-center">
                            <mat-divider class="col-10 "></mat-divider>
                        </div>
                    </div>
                    <div class="row mb-3">
                        <div class="col text-center">
                            Recouvrement de l'UR/station <b>{{computeRecouvrementUR1() | number:'1.2-2'}} % </b>

                            <!-- <mat-form-field class="w-100">
                            <input matInput placeholder="recouvrement de l'UR/station" type="number" [(ngModel)]="IBMRProcess.IBMRUniteReleve1.Recouvrement"
                                   [formControl]="IsRecouvrementUR1ValidControl" (keyup)="onRecouvrementUR1Event($event)">
                            <mat-error *ngIf="!IsRecouvrementUR1ValidControl.valid">
                                Recouvrement UR1 + UR2 doit être égal à 100%
                            </mat-error>
                        </mat-form-field> -->
                        </div>

                    </div>
                    <div class="row">
                        <div class="col-6">
                            <mat-form-field class="w-100">
                                <mat-label>Type d'unité</mat-label>
                                <mat-select placeholder="Type d'unité" [(ngModel)]="IBMRProcess.IBMRUniteReleve1.TypeUnite" (selectionChange)="TypeOfUnitChanged($event, 1)">
                                    <mat-option *ngFor="let p of UniteUR1List; let i = index" [value]="i + 1">
                                        <span>{{p}}</span>
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                        <div class="col-6">
                            <mat-form-field class="w-100">
                                <mat-label>Abondance Periphyton</mat-label>
                                <mat-select placeholder="Abondance Periphyton" [(ngModel)]="IBMRProcess.IBMRUniteReleve1.AbondancePeriphyton" required>
                                    <mat-option *ngFor="let p of AbondancePeriphytonList; let i = index" [value]="i + 1">
                                        <span>{{p}}</span>
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                    </div>

                </div>
            </div>

            <div class="col-12 col-xl-6 my-1">
                <div class="border rounded-1 background-light p-3">
                    <!-- <h5 class="card-header">Substrat</h5> -->
                    <div class="row">
                        <h2 class="col text-center fw-bold"> Substrat</h2>
                    </div>
                    <div class="row">
                        <div class="col-6">
                            <mat-form-field class="w-100">
                                <mat-label>Vase Limon</mat-label>
                                <mat-select placeholder="Vase Limon" [(ngModel)]="IBMRProcess.IBMRUniteReleve1.IBMRSubstrat.VaseLimon" required>
                                    <mat-option *ngFor="let p of RecouvrementList; let i = index" [value]="i">
                                        <span>{{p}}</span>
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                        <div class="col-6">
                            <mat-form-field class="w-100">
                                <mat-label>Pierre Galet</mat-label>
                                <mat-select placeholder="Pierre Galet" [(ngModel)]="IBMRProcess.IBMRUniteReleve1.IBMRSubstrat.PierreGalet" required>
                                    <mat-option *ngFor="let p of RecouvrementList; let i = index" [value]="i">
                                        <span>{{p}}</span>
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-6">
                            <mat-form-field class="w-100">
                                <mat-label>Sable Gravier</mat-label>
                                <mat-select placeholder="Sable Gravier" [(ngModel)]="IBMRProcess.IBMRUniteReleve1.IBMRSubstrat.SableGravier" required>
                                    <mat-option *ngFor="let p of RecouvrementList; let i = index" [value]="i">
                                        <span>{{p}}</span>
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                        <div class="col-6">
                            <mat-form-field class="w-100">
                                <mat-label>Terre Argile Marne</mat-label>
                                <mat-select placeholder="Terre Argile Marne" [(ngModel)]="IBMRProcess.IBMRUniteReleve1.IBMRSubstrat.TerreArgileMarne" required>
                                    <mat-option *ngFor="let p of RecouvrementList; let i = index" [value]="i">
                                        <span>{{p}}</span>
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-6">
                            <mat-form-field class="w-100">
                                <mat-label>Bloc Dalle</mat-label>
                                <mat-select placeholder="Bloc Dalle" [(ngModel)]="IBMRProcess.IBMRUniteReleve1.IBMRSubstrat.BlocDalle" required>
                                    <mat-option *ngFor="let p of RecouvrementList; let i = index" [value]="i">
                                        <span>{{p}}</span>
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                        <div class="col-6">
                            <mat-form-field class="w-100">
                                <mat-label>Débris Organique</mat-label>
                                <mat-select placeholder="Débris Organique" [(ngModel)]="IBMRProcess.IBMRUniteReleve1.IBMRSubstrat.DebrisOrganique" required>
                                    <mat-option *ngFor="let p of RecouvrementList; let i = index" [value]="i">
                                        <span>{{p}}</span>
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-6">
                            <mat-form-field class="w-100">
                                <mat-label>Artificiel</mat-label>
                                <mat-select placeholder="Artificiel" [(ngModel)]="IBMRProcess.IBMRUniteReleve1.IBMRSubstrat.Artificiel" required>
                                    <mat-option *ngFor="let p of RecouvrementList; let i = index" [value]="i">
                                        <span>{{p}}</span>
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                        <div class="col-6">
                            <mat-form-field class="w-100">
                                <mat-label>Racine Branchage</mat-label>
                                <mat-select placeholder="Racine Branchage" [(ngModel)]="IBMRProcess.IBMRUniteReleve1.IBMRSubstrat.RacineBranchage" required>
                                    <mat-option *ngFor="let p of RecouvrementList; let i = index" [value]="i">
                                        <span>{{p}}</span>
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-6">
                            <mat-form-field class="w-100">
                                <mat-label>Description Autre</mat-label>
                                <input matInput placeholder="Description Autre" [(ngModel)]="IBMRProcess.IBMRUniteReleve1.IBMRSubstrat.AutreDescription">
                            </mat-form-field>
                        </div>
                        <div class="col-6" *ngIf="IBMRProcess.IBMRUniteReleve1.IBMRSubstrat.AutreDescription">
                            <mat-form-field class="w-100">
                                <mat-label>Recouvrement Autre</mat-label>
                                <mat-select placeholder="Recouvrement Autre" [(ngModel)]="IBMRProcess.IBMRUniteReleve1.IBMRSubstrat.Autre" required>
                                    <mat-option *ngFor="let p of RecouvrementList; let i = index" [value]="i">
                                        <span>{{p}}</span>
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row" *ngIf="!ValidateSubstratClasses(IBMRProcess.IBMRUniteReleve1)">
                        <div class="col text-center">
                            <span style="color: red;">100% doit être absolument compris dans l'intervalle de la somme des classes</span>
                        </div>
                    </div>

                </div>
            </div>

            <div class="col-12 col-xl-6 my-1">
                <div class="border rounded-1 background-light p-3">
                    <!-- <h5 class="card-header">Profondeur (m)</h5> -->
                    <div class="row">
                        <h2 class="col text-center fw-bold"> Profondeur (m)</h2>
                    </div>
                    <div class="row">
                        <div class="col-6">
                            <mat-form-field class="w-100">
                                <mat-label>Inferieur à 0,1</mat-label>
                                <mat-select placeholder="Inferieur à 0,1" [(ngModel)]="IBMRProcess.IBMRUniteReleve1.IBMRProfondeur.PInferieur01" required>
                                    <mat-option *ngFor="let p of RecouvrementList; let i = index" [value]="i">
                                        <span>{{p}}</span>
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                        <div class="col-6">
                            <mat-form-field class="w-100">
                                <mat-label>Inferieur à 0,1 et 0,5</mat-label>
                                <mat-select placeholder="Entre 0,1 et 0,5" [(ngModel)]="IBMRProcess.IBMRUniteReleve1.IBMRProfondeur.PEntre01Et05" required>
                                    <mat-option *ngFor="let p of RecouvrementList; let i = index" [value]="i">
                                        <span>{{p}}</span>
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-6">
                            <mat-form-field class="w-100">
                                <mat-label>Entre 0,5 et 1</mat-label>
                                <mat-select placeholder="Entre 0,5 et 1" [(ngModel)]="IBMRProcess.IBMRUniteReleve1.IBMRProfondeur.PEntre05Et1" required>
                                    <mat-option *ngFor="let p of RecouvrementList; let i = index" [value]="i">
                                        <span>{{p}}</span>
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                        <div class="col-6">
                            <mat-form-field class="w-100">
                                <mat-label>Entre 1 et 2"</mat-label>
                                <mat-select placeholder="Entre 1 et 2" [(ngModel)]="IBMRProcess.IBMRUniteReleve1.IBMRProfondeur.PEntre1Et2" required>
                                    <mat-option *ngFor="let p of RecouvrementList; let i = index" [value]="i">
                                        <span>{{p}}</span>
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-6">
                            <mat-form-field class="w-100">
                                <mat-label>Supérieur à 2"</mat-label>
                                <mat-select placeholder="Supérieur à 2" [(ngModel)]="IBMRProcess.IBMRUniteReleve1.IBMRProfondeur.PSuperieur2" required>
                                    <mat-option *ngFor="let p of RecouvrementList; let i = index" [value]="i">
                                        <span>{{p}}</span>
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row" *ngIf="!ValidateProfondeurClasses(IBMRProcess.IBMRUniteReleve1)">
                        <div class="col text-center">
                            <span style="color: red;">100% doit être absolument compris dans l'intervalle de la somme des classes</span>
                        </div>
                    </div>

                </div>
            </div>

            <div class="col-12 col-xl-6 my-1">
                <div class="border rounded-1 background-light p-3">
                    <!-- <h5 class="card-header">Facies ecoulement</h5> -->
                    <div class="row">
                        <h2 class="col text-center fw-bold"> Facies ecoulement</h2>
                    </div>
                    <div class="row">
                        <div class="col-6">
                            <mat-form-field class="w-100">
                                <mat-label>Radier"</mat-label>
                                <mat-select placeholder="Radier" [(ngModel)]="IBMRProcess.IBMRUniteReleve1.IBMRFaciesEcoulement.Radier" required>
                                    <mat-option *ngFor="let p of RecouvrementList; let i = index" [value]="i">
                                        <span>{{p}}</span>
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                        <div class="col-6">
                            <mat-form-field class="w-100">
                                <mat-label>Cascade</mat-label>
                                <mat-select placeholder="Cascade" [(ngModel)]="IBMRProcess.IBMRUniteReleve1.IBMRFaciesEcoulement.Cascade" required>
                                    <mat-option *ngFor="let p of RecouvrementList; let i = index" [value]="i">
                                        <span>{{p}}</span>
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-6">
                            <mat-form-field class="w-100">
                                <mat-label>Mouille"</mat-label>
                                <mat-select placeholder="Mouille" [(ngModel)]="IBMRProcess.IBMRUniteReleve1.IBMRFaciesEcoulement.Mouille" required>
                                    <mat-option *ngFor="let p of RecouvrementList; let i = index" [value]="i">
                                        <span>{{p}}</span>
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                        <div class="col-6">
                            <mat-form-field class="w-100">
                                <mat-label>Rapide"</mat-label>
                                <mat-select placeholder="Rapide" [(ngModel)]="IBMRProcess.IBMRUniteReleve1.IBMRFaciesEcoulement.Rapide" required>
                                    <mat-option *ngFor="let p of RecouvrementList; let i = index" [value]="i">
                                        <span>{{p}}</span>
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-6">
                            <mat-form-field class="w-100">
                                <mat-label>Fosse Dissipation"</mat-label>
                                <mat-select placeholder="Fosse Dissipation" [(ngModel)]="IBMRProcess.IBMRUniteReleve1.IBMRFaciesEcoulement.FosseDissipation"
                                            required>
                                    <mat-option *ngFor="let p of RecouvrementList; let i = index" [value]="i">
                                        <span>{{p}}</span>
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                        <div class="col-6">
                            <mat-form-field class="w-100">
                                <mat-label>Chenal Lotique"</mat-label>
                                <mat-select placeholder="Chenal Lotique" [(ngModel)]="IBMRProcess.IBMRUniteReleve1.IBMRFaciesEcoulement.ChenalLotique" required>
                                    <mat-option *ngFor="let p of RecouvrementList; let i = index" [value]="i">
                                        <span>{{p}}</span>
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-6">
                            <mat-form-field class="w-100">
                                <mat-label>Plat Lentique"</mat-label>
                                <mat-select placeholder="Plat Lentique" [(ngModel)]="IBMRProcess.IBMRUniteReleve1.IBMRFaciesEcoulement.PlatLentique" required>
                                    <mat-option *ngFor="let p of RecouvrementList; let i = index" [value]="i">
                                        <span>{{p}}</span>
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                        <div class="col-6">
                            <mat-form-field class="w-100">
                                <mat-label>Chenal Lentique"</mat-label>
                                <mat-select placeholder="Chenal Lentique" [(ngModel)]="IBMRProcess.IBMRUniteReleve1.IBMRFaciesEcoulement.ChenalLentique"
                                            required>
                                    <mat-option *ngFor="let p of RecouvrementList; let i = index" [value]="i">
                                        <span>{{p}}</span>
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-6">
                            <mat-form-field class="w-100">
                                <mat-label>Zone De Bordure"</mat-label>
                                <mat-select placeholder="Zone De Bordure" [(ngModel)]="IBMRProcess.IBMRUniteReleve1.IBMRFaciesEcoulement.ZoneDeBordure"
                                            required>
                                    <mat-option *ngFor="let p of RecouvrementList; let i = index" [value]="i">
                                        <span>{{p}}</span>
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                        <div class="col-6">
                            <mat-form-field class="w-100">
                                <mat-label>Plat Courant"</mat-label>
                                <mat-select placeholder="Plat Courant" [(ngModel)]="IBMRProcess.IBMRUniteReleve1.IBMRFaciesEcoulement.PlatCourant" required>
                                    <mat-option *ngFor="let p of RecouvrementList; let i = index" [value]="i">
                                        <span>{{p}}</span>
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-6">
                            <mat-form-field class="w-100">
                                <mat-label>Description Autre"</mat-label>
                                <input matInput placeholder="Description Autre"
                                       [(ngModel)]="IBMRProcess.IBMRUniteReleve1.IBMRFaciesEcoulement.AutreDescription">
                            </mat-form-field>
                        </div>
                        <div class="col-6">
                            <mat-form-field class="w-100">
                                <mat-label>Recouvrement Autre"</mat-label>
                                <mat-select placeholder="Recouvrement Autre" [(ngModel)]="IBMRProcess.IBMRUniteReleve1.IBMRFaciesEcoulement.Autre" required>
                                    <mat-option *ngFor="let p of RecouvrementList; let i = index" [value]="i">
                                        <span>{{p}}</span>
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row" *ngIf="!ValidateFaciesEcoulementClasses(IBMRProcess.IBMRUniteReleve1)">
                        <div class="col text-center">
                            <span style="color: red;">100% doit être absolument compris dans l'intervalle de la somme des classes</span>
                        </div>
                    </div>

                </div>
            </div>

            <div class="col-12 col-xl-6 my-1">
                <div class="border rounded-1 background-light p-3">
                    <!-- <h5 class="card-header">Eclairement</h5> -->
                    <div class="row">
                        <h2 class="col text-center fw-bold"> Eclairement</h2>
                    </div>
                    <div class="row">
                        <div class="col-6">
                            <mat-form-field class="w-100">
                                <mat-label>Tres Ombrage"</mat-label>
                                <mat-select placeholder="Tres Ombrage" [(ngModel)]="IBMRProcess.IBMRUniteReleve1.IBMREclairement.TresOmbrage" required>
                                    <mat-option *ngFor="let p of RecouvrementList; let i = index" [value]="i">
                                        <span>{{p}}</span>
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                        <div class="col-6">
                            <mat-form-field class="w-100">
                                <mat-label>Ombrage"</mat-label>
                                <mat-select placeholder="Ombrage" [(ngModel)]="IBMRProcess.IBMRUniteReleve1.IBMREclairement.Ombrage" required>
                                    <mat-option *ngFor="let p of RecouvrementList; let i = index" [value]="i">
                                        <span>{{p}}</span>
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-6">
                            <mat-form-field class="w-100">
                                <mat-label>Peu Ombrage"</mat-label>
                                <mat-select placeholder="Peu Ombrage" [(ngModel)]="IBMRProcess.IBMRUniteReleve1.IBMREclairement.PeuOmbrage" required>
                                    <mat-option *ngFor="let p of RecouvrementList; let i = index" [value]="i">
                                        <span>{{p}}</span>
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                        <div class="col-6">
                            <mat-form-field class="w-100">
                                <mat-label>Eclaire"</mat-label>
                                <mat-select placeholder="Eclaire" [(ngModel)]="IBMRProcess.IBMRUniteReleve1.IBMREclairement.Eclaire" required>
                                    <mat-option *ngFor="let p of RecouvrementList; let i = index" [value]="i">
                                        <span>{{p}}</span>
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-6">
                            <mat-form-field class="w-100">
                                <mat-label>Tres Eclaire"</mat-label>
                                <mat-select placeholder="Tres Eclaire" [(ngModel)]="IBMRProcess.IBMRUniteReleve1.IBMREclairement.TresEclaire" required>
                                    <mat-option *ngFor="let p of RecouvrementList; let i = index" [value]="i">
                                        <span>{{p}}</span>
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row" *ngIf="!ValidateEclairementClasses(IBMRProcess.IBMRUniteReleve1)">
                        <div class="col text-center">
                            <span style="color: red;">100% doit être absolument compris dans l'intervalle de la somme des classes</span>
                        </div>
                    </div>

                </div>
            </div>

            <div class="col-12 col-xl-6 my-1">
                <div class="border rounded-1 background-light p-3">
                    <!-- <h5 class="card-header">Vitesse Courant (m/s)</h5> -->
                    <div class="row">
                        <h2 class="col text-center fw-bold"> Vitesse Courant (m/s)</h2>
                    </div>
                    <div class="row">
                        <div class="col-6">
                            <mat-form-field class="w-100">
                                <mat-label>Inférieur à 0,05</mat-label>
                                <mat-select placeholder="Inférieur à 0,05" [(ngModel)]="IBMRProcess.IBMRUniteReleve1.IBMRVitesseCourant.VInferieur005" required>
                                    <mat-option *ngFor="let p of RecouvrementList; let i = index" [value]="i">
                                        <span>{{p}}</span>
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                        <div class="col-6">
                            <mat-form-field class="w-100">
                                <mat-label>Entre 0,05 et 02</mat-label>
                                <mat-select placeholder="Entre 0,05 et 02" [(ngModel)]="IBMRProcess.IBMRUniteReleve1.IBMRVitesseCourant.VEntre005Et02"
                                            required>
                                    <mat-option *ngFor="let p of RecouvrementList; let i = index" [value]="i">
                                        <span>{{p}}</span>
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-6">
                            <mat-form-field class="w-100">
                                <mat-label>Entre 0,2 et 0,5</mat-label>
                                <mat-select placeholder="Entre 0,2 et 0,5" [(ngModel)]="IBMRProcess.IBMRUniteReleve1.IBMRVitesseCourant.VEntre02Et05" required>
                                    <mat-option *ngFor="let p of RecouvrementList; let i = index" [value]="i">
                                        <span>{{p}}</span>
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                        <div class="col-6">
                            <mat-form-field class="w-100">
                                <mat-label>Entre 0,5 et 1</mat-label>
                                <mat-select placeholder="Entre 0,5 et 1" [(ngModel)]="IBMRProcess.IBMRUniteReleve1.IBMRVitesseCourant.VEntre05Et1" required>
                                    <mat-option *ngFor="let p of RecouvrementList; let i = index" [value]="i">
                                        <span>{{p}}</span>
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-6">
                            <mat-form-field class="w-100">
                                <mat-label>Supérieur à 1</mat-label>
                                <mat-select placeholder="Supérieur à 1" [(ngModel)]="IBMRProcess.IBMRUniteReleve1.IBMRVitesseCourant.VSuperieur1" required>
                                    <mat-option *ngFor="let p of RecouvrementList; let i = index" [value]="i">
                                        <span>{{p}}</span>
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row" *ngIf="!ValidateVitesseCourantClasses(IBMRProcess.IBMRUniteReleve1)">
                        <div class="col text-center">
                            <span style="color: red;">100% doit être absolument compris dans l'intervalle de la somme des classes</span>
                        </div>
                    </div>

                </div>
            </div>

            <div class="col-12 col-xl-6 my-1">
                <div class="border rounded-1 background-light p-3">
                    <!-- <h5 class="card-header">Végétation Aquatique</h5> -->
                    <div class="row">
                        <h2 class="col text-center fw-bold"> Végétation Aquatique</h2>
                    </div>
                    <div class="row">
                        <div class="col-12">
                            <mat-form-field class="w-100">
                                <mat-label>Surface Vegetalisee</mat-label>
                                <input matInput placeholder="Surface Vegetalisee" type="number" [(ngModel)]="IBMRProcess.IBMRUniteReleve1.SurfaceVegetalisee">
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-6">
                            <mat-form-field class="w-100">
                                <mat-label>Heterotrophes</mat-label>
                                <input matInput placeholder="Heterotrophes" type="number"
                                       [(ngModel)]="IBMRProcess.IBMRUniteReleve1.IBMRVegetationAquatique.Heterotrophes">
                            </mat-form-field>
                        </div>
                        <div class="col-6">
                            <mat-form-field class="w-100">
                                <mat-label>Algues</mat-label>
                                <input matInput placeholder="Algues" type="number" [(ngModel)]="IBMRProcess.IBMRUniteReleve1.IBMRVegetationAquatique.Algues">
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-6">
                            <mat-form-field class="w-100">
                                <mat-label>Bryophytes</mat-label>
                                <input matInput placeholder="Bryophytes" type="number"
                                       [(ngModel)]="IBMRProcess.IBMRUniteReleve1.IBMRVegetationAquatique.Bryophytes">
                            </mat-form-field>
                        </div>
                        <div class="col-6">
                            <mat-form-field class="w-100">
                                <mat-label>Pteridophytes</mat-label>
                                <input matInput placeholder="Pteridophytes" type="number"
                                       [(ngModel)]="IBMRProcess.IBMRUniteReleve1.IBMRVegetationAquatique.Pteridophytes">
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-6">
                            <mat-form-field class="w-100">
                                <mat-label>Phanerogames</mat-label>
                                <input matInput placeholder="Phanerogames" type="number"
                                       [(ngModel)]="IBMRProcess.IBMRUniteReleve1.IBMRVegetationAquatique.Phanerogames">
                            </mat-form-field>
                        </div>
                        <div class="col-6">
                            <mat-form-field class="w-100">
                                <mat-label>Hydrophytes Flottants</mat-label>
                                <input matInput placeholder="Hydrophytes Flottants" type="number"
                                       [(ngModel)]="IBMRProcess.IBMRUniteReleve1.IBMRVegetationAquatique.HydrophytesFlottants">
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-6">
                            <mat-form-field class="w-100">
                                <mat-label>Hydrophytes Immerges</mat-label>
                                <input matInput placeholder="Hydrophytes Immerges" type="number"
                                       [(ngModel)]="IBMRProcess.IBMRUniteReleve1.IBMRVegetationAquatique.HydrophytesImmerges">
                            </mat-form-field>
                        </div>
                        <div class="col-6">
                            <mat-form-field class="w-100">
                                <mat-label>Helophytes</mat-label>
                                <input matInput placeholder="Helophytes" type="number"
                                       [(ngModel)]="IBMRProcess.IBMRUniteReleve1.IBMRVegetationAquatique.Helophytes">
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row" *ngIf="!ValidateVegationEquality(IBMRProcess.IBMRUniteReleve1.IBMRVegetationAquatique)">
                        <div class="col text-center">
                            <span style="color: orange;">Heterotrophes + Algues + Bryophytes + Pteridophytes + Phanerogames doit être égal à HydrophytesFlottants + HydrophytesImmerges +
                                Helophytes</span>
                        </div>
                    </div>

                </div>
            </div>
            <!-- 
        <div class="col-12 my-3 d-flex justify-content-center">
            <mat-checkbox [(ngModel)]="IBMRProcess.HasUR2">Besoin d'une deuxième UR ?</mat-checkbox>
        </div> -->

            <div *ngIf="IBMRProcess.HasUR2" class="col-12 my-1">
                <div class="display-5 text-center">
                    Unite de releve 2
                </div>
            </div>

            <div *ngIf="IBMRProcess.HasUR2" class="col-12 col-xl-6 my-1">
                <div class="border rounded-1 background-light p-3">
                    <!-- <h5 class="card-header">Unite de releve</h5> -->
                    <div class="row">
                        <h2 class="col text-center fw-bold"> Unite de releve</h2>
                    </div>
                    <div class="row">
                        <div class="col-6">
                            <mat-form-field class="w-100">
                                <mat-label>Longueur</mat-label>
                                <input matInput placeholder="Longueur" type="number" [ngModel]="computeLongueurForUR(IBMRProcess.IBMRUniteReleve2)" readonly>
                            </mat-form-field>
                        </div>
                        <div class="col-6">
                            Largeur {{computeLargeurForUR(IBMRProcess.IBMRUniteReleve2) | number:'1.2-2'}}
                        </div>
                    </div>
                    <div class="row mt-3">
                        <h6 class="d-flex align-items-center m-0 col-auto">Liste des transects</h6>

                        <button appPreventDoubleClick [throttleTime]="200" mat-icon-button color="primary" (throttledClick)="openMesureBoxForTransect(IBMRProcess.IBMRUniteReleve2)">
                            <mat-icon>add</mat-icon>
                        </button>
                    </div>
                    <div class="row mt-3 justify-content-center">
                        <div *ngFor="let largueur of IBMRProcess.IBMRUniteReleve2.IBMRTransectList; let i = index" class="col-auto text-center my-1">
                            <div class="row">

                                <div class="col"></div>
                                <div class="col align-content-center">
                                    <h5>Transect {{i + 1}}</h5>
                                </div>

                                <div class="col p-0 d-flex justify-content-center">
                                    <button appPreventDoubleClick [throttleTime]="200" mat-icon-button color="primary"
                                            (throttledClick)="openMesureBoxForTransect(IBMRProcess.IBMRUniteReleve2, largueur)">
                                        <mat-icon>edit</mat-icon>
                                    </button>
                                    <button appPreventDoubleClick [throttleTime]="200" mat-icon-button color="primary" (throttledClick)="removeTransect(largueur, IBMRProcess.IBMRUniteReleve2)">
                                        <mat-icon>delete</mat-icon>
                                    </button>
                                </div>
                            </div>

                            <div class=" p-1 m-1 background-light">

                                <div class="row justify-content-center">
                                    <div class="col-6">
                                        <mat-form-field class="w-100">
                                            <mat-label>{{getLongueur(i)}}</mat-label>
                                            <input matInput [placeholder]="getLongueur(i)" type="number" [(ngModel)]="largueur.LpB" disabled="true">
                                        </mat-form-field>
                                    </div>

                                    <div class="col-6">
                                        <mat-form-field class="w-100">
                                            <mat-label>{{getLm(i)}}</mat-label>
                                            <input matInput [placeholder]="getLm(i)" type="number" [(ngModel)]="largueur.Lm" disabled="true">
                                        </mat-form-field>
                                    </div>

                                </div>
                                
                            </div>

                            <div class="col-auto text-center my-1">
                                <div *ngFor="let taxon of largueur.TaxonList; let i = index" (click)="openTaxonIBMRBox(largueur, taxon)">
                                    <div class="border rounded-1 p-1 m-1 " [class.background-orange]="taxon.Preleve" [class.background-violet-accent]="!taxon.Preleve">

                                        <div class="row justify-content-between">
                                            <div class="col-auto">

                                            </div>
                                            <h3 class="col text-center" [matTooltip]="taxon.Comment" [matTooltipDisabled]="taxon.Comment !== undefined && taxon.Comment !== ''">
                                                {{taxon.Code}} 
                                            </h3>
                                            <div class="col-auto">
                                                <button appPreventDoubleClick mat-icon-button color="primary" (throttledClick)="deleteTaxon(largueur, taxon)">
                                                    <mat-icon>clear</mat-icon>
                                                </button>
                                            </div>
                                        </div>
                                        <h3 *ngIf="taxon.Preleve" class="text-center"> {{taxon.CustomName}}</h3>

                                        <div *ngIf="!taxon.Presence" class=" text-center fw-bold"> Quantité: {{taxon.Quantite}} {{getUnitName(taxon.Unit)}}</div>
                                        <div *ngIf="taxon.Presence" class=" text-center fw-bold"> Présence</div>

                                        <div *ngIf="!taxon.Preleve" class="text-center"> {{taxon.NomOrdre}}</div>
                                        <div *ngIf="!taxon.Preleve" class="text-center"> {{taxon.NomFamille}}</div>
                                        <div *ngIf="!taxon.Preleve" class="text-center"> {{taxon.NomGenre}}</div>

                                        <div *ngIf="taxon.Preleve" class="text-center"> P{{taxon.NumeroPrelevement}}</div>

                                        <div class="text-center fst-italic"> {{taxon.Comment}}</div>
                                    </div>

                                </div>
                            </div>
                            <button appPreventDoubleClick [throttleTime]="200" mat-raised-button color="accent" (throttledClick)="openTaxonIBMRBox(largueur)">
                                Ajouter un taxon
                            </button>
                            <div class="row my-3 justify-content-center">
                                <mat-divider class="col-10 "></mat-divider>
                            </div>
                        </div>
                        <div class="row mb-3">
                            <div class="col text-center">
                                Recouvrement de l'UR/station <b>{{computeRecouvrementUR2() | number:'1.2-2'}} % </b>

                                <!-- <mat-form-field class="w-100">
                                <input matInput placeholder="recouvrement de l'UR/station" type="number" [(ngModel)]="IBMRProcess.IBMRUniteReleve1.Recouvrement"
                                       [formControl]="IsRecouvrementUR1ValidControl" (keyup)="onRecouvrementUR1Event($event)">
                                <mat-error *ngIf="!IsRecouvrementUR1ValidControl.valid">
                                    Recouvrement UR1 + UR2 doit être égal à 100%
                                </mat-error>
                            </mat-form-field> -->
                            </div>

                        </div>
                        <div class="row">
                            <div class="col-6">
                                <mat-form-field class="w-100">
                                    <mat-label>Type d'unité</mat-label>
                                    <mat-select placeholder="Type d'unité" [(ngModel)]="IBMRProcess.IBMRUniteReleve2.TypeUnite" (selectionChange)="TypeOfUnitChanged($event, 2)">
                                        <mat-option *ngFor="let p of UniteUR2List; let i = index" [value]="i + 1">
                                            <span>{{p}}</span>
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                            <div class="col-6">
                                <mat-form-field class="w-100">
                                    <mat-label>Abondance Periphyton</mat-label>
                                    <mat-select placeholder="Abondance Periphyton" [(ngModel)]="IBMRProcess.IBMRUniteReleve2.AbondancePeriphyton" required>
                                        <mat-option *ngFor="let p of AbondancePeriphytonList; let i = index" [value]="i + 1">
                                            <span>{{p}}</span>
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                        </div>

                    </div>

                </div>
            </div>

            <div *ngIf="IBMRProcess.HasUR2" class="col-12 col-xl-6 my-1">
                <div class="border rounded-1 background-light p-3">
                    <!-- <h5 class="card-header">Substrat</h5> -->
                    <div class="row">
                        <h2 class="col text-center fw-bold"> Substrat</h2>
                    </div>
                    <div class="row">
                        <div class="col-6">
                            <mat-form-field class="w-100">
                                <mat-label>Vase Limon</mat-label>
                                <mat-select placeholder="Vase Limon" [(ngModel)]="IBMRProcess.IBMRUniteReleve2.IBMRSubstrat.VaseLimon" required>
                                    <mat-option *ngFor="let p of RecouvrementList; let i = index" [value]="i">
                                        <span>{{p}}</span>
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                        <div class="col-6">
                            <mat-form-field class="w-100">
                                <mat-label>Pierre Galet</mat-label>
                                <mat-select placeholder="Pierre Galet" [(ngModel)]="IBMRProcess.IBMRUniteReleve2.IBMRSubstrat.PierreGalet" required>
                                    <mat-option *ngFor="let p of RecouvrementList; let i = index" [value]="i">
                                        <span>{{p}}</span>
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-6">
                            <mat-form-field class="w-100">
                                <mat-label>Sable Gravier</mat-label>
                                <mat-select placeholder="Sable Gravier" [(ngModel)]="IBMRProcess.IBMRUniteReleve2.IBMRSubstrat.SableGravier" required>
                                    <mat-option *ngFor="let p of RecouvrementList; let i = index" [value]="i">
                                        <span>{{p}}</span>
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                        <div class="col-6">
                            <mat-form-field class="w-100">
                                <mat-label>Terre Argile Marne</mat-label>
                                <mat-select placeholder="Terre Argile Marne" [(ngModel)]="IBMRProcess.IBMRUniteReleve2.IBMRSubstrat.TerreArgileMarne"
                                            required>
                                    <mat-option *ngFor="let p of RecouvrementList; let i = index" [value]="i">
                                        <span>{{p}}</span>
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-6">
                            <mat-form-field class="w-100">
                                <mat-label>Bloc Dalle</mat-label>
                                <mat-select placeholder="Bloc Dalle" [(ngModel)]="IBMRProcess.IBMRUniteReleve2.IBMRSubstrat.BlocDalle" required>
                                    <mat-option *ngFor="let p of RecouvrementList; let i = index" [value]="i">
                                        <span>{{p}}</span>
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                        <div class="col-6">
                            <mat-form-field class="w-100">
                                <mat-label>Debris Organique</mat-label>
                                <mat-select placeholder="Debris Organique" [(ngModel)]="IBMRProcess.IBMRUniteReleve2.IBMRSubstrat.DebrisOrganique" required>
                                    <mat-option *ngFor="let p of RecouvrementList; let i = index" [value]="i">
                                        <span>{{p}}</span>
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-6">
                            <mat-form-field class="w-100">
                                <mat-label>Artificiel</mat-label>
                                <mat-select placeholder="Artificiel" [(ngModel)]="IBMRProcess.IBMRUniteReleve2.IBMRSubstrat.Artificiel" required>
                                    <mat-option *ngFor="let p of RecouvrementList; let i = index" [value]="i">
                                        <span>{{p}}</span>
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                        <div class="col-6">
                            <mat-form-field class="w-100">
                                <mat-label>Racine Branchage</mat-label>
                                <mat-select placeholder="Racine Branchage" [(ngModel)]="IBMRProcess.IBMRUniteReleve2.IBMRSubstrat.RacineBranchage" required>
                                    <mat-option *ngFor="let p of RecouvrementList; let i = index" [value]="i">
                                        <span>{{p}}</span>
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-6">
                            <mat-form-field class="w-100">
                                <mat-label>Description Autre</mat-label>
                                <input matInput placeholder="Description Autre" [(ngModel)]="IBMRProcess.IBMRUniteReleve2.IBMRSubstrat.AutreDescription">
                            </mat-form-field>
                        </div>
                        <div class="col-6" *ngIf="IBMRProcess.IBMRUniteReleve2.IBMRSubstrat.AutreDescription">
                            <mat-form-field class="w-100">
                                <mat-label>Recouvrement Autre</mat-label>
                                <mat-select placeholder="Recouvrement Autre" [(ngModel)]="IBMRProcess.IBMRUniteReleve2.IBMRSubstrat.Autre" required>
                                    <mat-option *ngFor="let p of RecouvrementList; let i = index" [value]="i">
                                        <span>{{p}}</span>
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row" *ngIf="!ValidateSubstratClasses(IBMRProcess.IBMRUniteReleve2)">
                        <div class="col text-center">
                            <span style="color: red;">100% doit être absolument compris dans l'intervalle de la somme des classes</span>
                        </div>
                    </div>

                </div>
            </div>

            <div *ngIf="IBMRProcess.HasUR2" class="col-12 col-xl-6 my-1">
                <div class="border rounded-1 background-light p-3">
                    <!-- <h5 class="card-header">Profondeur (m)</h5> -->
                    <div class="row">
                        <h2 class="col text-center fw-bold"> Profondeur (m)</h2>
                    </div>
                    <div class="row">
                        <div class="col-6">
                            <mat-form-field class="w-100">
                                <mat-label>Inférieur à 0,1</mat-label>
                                <mat-select placeholder="Inférieur à 0,1" [(ngModel)]="IBMRProcess.IBMRUniteReleve2.IBMRProfondeur.PInferieur01" required>
                                    <mat-option *ngFor="let p of RecouvrementList; let i = index" [value]="i">
                                        <span>{{p}}</span>
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                        <div class="col-6">
                            <mat-form-field class="w-100">
                                <mat-label>Entre 0,1 et 0,5</mat-label>
                                <mat-select placeholder="Entre 0,1 et 0,5" [(ngModel)]="IBMRProcess.IBMRUniteReleve2.IBMRProfondeur.PEntre01Et05" required>
                                    <mat-option *ngFor="let p of RecouvrementList; let i = index" [value]="i">
                                        <span>{{p}}</span>
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-6">
                            <mat-form-field class="w-100">
                                <mat-label>Entre 0,5 et 1</mat-label>
                                <mat-select placeholder="Entre 0,5 et 1" [(ngModel)]="IBMRProcess.IBMRUniteReleve2.IBMRProfondeur.PEntre05Et1" required>
                                    <mat-option *ngFor="let p of RecouvrementList; let i = index" [value]="i">
                                        <span>{{p}}</span>
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                        <div class="col-6">
                            <mat-form-field class="w-100">
                                <mat-label>Entre 1 et 2</mat-label>
                                <mat-select placeholder="Entre 1 et 2" [(ngModel)]="IBMRProcess.IBMRUniteReleve2.IBMRProfondeur.PEntre1Et2" required>
                                    <mat-option *ngFor="let p of RecouvrementList; let i = index" [value]="i">
                                        <span>{{p}}</span>
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-6">
                            <mat-form-field class="w-100">
                                <mat-label>Supérieur à 2</mat-label>
                                <mat-select placeholder="Supérieur à 2" [(ngModel)]="IBMRProcess.IBMRUniteReleve2.IBMRProfondeur.PSuperieur2" required>
                                    <mat-option *ngFor="let p of RecouvrementList; let i = index" [value]="i">
                                        <span>{{p}}</span>
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row" *ngIf="!ValidateProfondeurClasses(IBMRProcess.IBMRUniteReleve2)">
                        <div class="col text-center">
                            <span style="color: red;">100% doit être absolument compris dans l'intervalle de la somme des classes</span>
                        </div>
                    </div>

                </div>
            </div>

            <div *ngIf="IBMRProcess.HasUR2" class="col-12 col-xl-6 my-1">
                <div class="border rounded-1 background-light p-3">
                    <!-- <h5 class="card-header">Facies ecoulement</h5> -->
                    <div class="row">
                        <h2 class="col text-center fw-bold"> Facies ecoulement</h2>
                    </div>
                    <div class="row">
                        <div class="col-6">
                            <mat-form-field class="w-100">
                                <mat-label>Radier</mat-label>
                                <mat-select placeholder="Radier" [(ngModel)]="IBMRProcess.IBMRUniteReleve2.IBMRFaciesEcoulement.Radier" required>
                                    <mat-option *ngFor="let p of RecouvrementList; let i = index" [value]="i">
                                        <span>{{p}}</span>
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                        <div class="col-6">
                            <mat-form-field class="w-100">
                                <mat-label>Cascade</mat-label>
                                <mat-select placeholder="Cascade" [(ngModel)]="IBMRProcess.IBMRUniteReleve2.IBMRFaciesEcoulement.Cascade" required>
                                    <mat-option *ngFor="let p of RecouvrementList; let i = index" [value]="i">
                                        <span>{{p}}</span>
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-6">
                            <mat-form-field class="w-100">
                                <mat-label>Mouille</mat-label>
                                <mat-select placeholder="Mouille" [(ngModel)]="IBMRProcess.IBMRUniteReleve2.IBMRFaciesEcoulement.Mouille" required>
                                    <mat-option *ngFor="let p of RecouvrementList; let i = index" [value]="i">
                                        <span>{{p}}</span>
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                        <div class="col-6">
                            <mat-form-field class="w-100">
                                <mat-label>Rapide</mat-label>
                                <mat-select placeholder="Rapide" [(ngModel)]="IBMRProcess.IBMRUniteReleve2.IBMRFaciesEcoulement.Rapide" required>
                                    <mat-option *ngFor="let p of RecouvrementList; let i = index" [value]="i">
                                        <span>{{p}}</span>
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-6">
                            <mat-form-field class="w-100">
                                <mat-label>Fosse Dissipation</mat-label>
                                <mat-select placeholder="Fosse Dissipation" [(ngModel)]="IBMRProcess.IBMRUniteReleve2.IBMRFaciesEcoulement.FosseDissipation"
                                            required>
                                    <mat-option *ngFor="let p of RecouvrementList; let i = index" [value]="i">
                                        <span>{{p}}</span>
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                        <div class="col-6">
                            <mat-form-field class="w-100">
                                <mat-label>Chenal Lotique</mat-label>
                                <mat-select placeholder="Chenal Lotique" [(ngModel)]="IBMRProcess.IBMRUniteReleve2.IBMRFaciesEcoulement.ChenalLotique"
                                            required>
                                    <mat-option *ngFor="let p of RecouvrementList; let i = index" [value]="i">
                                        <span>{{p}}</span>
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-6">
                            <mat-form-field class="w-100">
                                <mat-label>Plat Lentique</mat-label>
                                <mat-select placeholder="Plat Lentique" [(ngModel)]="IBMRProcess.IBMRUniteReleve2.IBMRFaciesEcoulement.PlatLentique"
                                            required>
                                    <mat-option *ngFor="let p of RecouvrementList; let i = index" [value]="i">
                                        <span>{{p}}</span>
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                        <div class="col-6">
                            <mat-form-field class="w-100">
                                <mat-label>Chenal Lentique</mat-label>
                                <mat-select placeholder="Chenal Lentique" [(ngModel)]="IBMRProcess.IBMRUniteReleve2.IBMRFaciesEcoulement.ChenalLentique"
                                            required>
                                    <mat-option *ngFor="let p of RecouvrementList; let i = index" [value]="i">
                                        <span>{{p}}</span>
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-6">
                            <mat-form-field class="w-100">
                                <mat-label>Zone De Bordure</mat-label>
                                <mat-select placeholder="Zone De Bordure" [(ngModel)]="IBMRProcess.IBMRUniteReleve2.IBMRFaciesEcoulement.ZoneDeBordure"
                                            required>
                                    <mat-option *ngFor="let p of RecouvrementList; let i = index" [value]="i">
                                        <span>{{p}}</span>
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                        <div class="col-6">
                            <mat-form-field class="w-100">
                                <mat-label>Plat Courant</mat-label>
                                <mat-select placeholder="Plat Courant" [(ngModel)]="IBMRProcess.IBMRUniteReleve2.IBMRFaciesEcoulement.PlatCourant" required>
                                    <mat-option *ngFor="let p of RecouvrementList; let i = index" [value]="i">
                                        <span>{{p}}</span>
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-6">
                            <mat-form-field class="w-100">
                                <mat-label>Description Autre</mat-label>
                                <input matInput placeholder="Description Autre"
                                       [(ngModel)]="IBMRProcess.IBMRUniteReleve2.IBMRFaciesEcoulement.AutreDescription">
                            </mat-form-field>
                        </div>
                        <div class="col-6">
                            <mat-form-field class="w-100">
                                <mat-label>Recouvrement Autre</mat-label>
                                <mat-select placeholder="Recouvrement Autre" [(ngModel)]="IBMRProcess.IBMRUniteReleve2.IBMRFaciesEcoulement.Autre"
                                            required>
                                    <mat-option *ngFor="let p of RecouvrementList; let i = index" [value]="i">
                                        <span>{{p}}</span>
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row" *ngIf="!ValidateFaciesEcoulementClasses(IBMRProcess.IBMRUniteReleve2)">
                        <div class="col text-center">
                            <span style="color: red;">100% doit être absolument compris dans l'intervalle de la somme des classes</span>
                        </div>
                    </div>

                </div>
            </div>

            <div *ngIf="IBMRProcess.HasUR2" class="col-12 col-xl-6 my-1">
                <div class="border rounded-1 background-light p-3">
                    <!-- <h5 class="card-header">Eclairement</h5> -->
                    <div class="row">
                        <h2 class="col text-center fw-bold"> Eclairement</h2>
                    </div>
                    <div class="row">
                        <div class="col-6">
                            <mat-form-field class="w-100">
                                <mat-label>Tres Ombrage</mat-label>
                                <mat-select placeholder="Tres Ombrage" [(ngModel)]="IBMRProcess.IBMRUniteReleve2.IBMREclairement.TresOmbrage" required>
                                    <mat-option *ngFor="let p of RecouvrementList; let i = index" [value]="i">
                                        <span>{{p}}</span>
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                        <div class="col-6">
                            <mat-form-field class="w-100">
                                <mat-label> Ombrage</mat-label>
                                <mat-select placeholder="Ombrage" [(ngModel)]="IBMRProcess.IBMRUniteReleve2.IBMREclairement.Ombrage" required>
                                    <mat-option *ngFor="let p of RecouvrementList; let i = index" [value]="i">
                                        <span>{{p}}</span>
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-6">
                            <mat-form-field class="w-100">
                                <mat-label>Peu Ombrage</mat-label>
                                <mat-select placeholder="Peu Ombrage" [(ngModel)]="IBMRProcess.IBMRUniteReleve2.IBMREclairement.PeuOmbrage" required>
                                    <mat-option *ngFor="let p of RecouvrementList; let i = index" [value]="i">
                                        <span>{{p}}</span>
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                        <div class="col-6">
                            <mat-form-field class="w-100">
                                <mat-label>Eclaire</mat-label>
                                <mat-select placeholder="Eclaire" [(ngModel)]="IBMRProcess.IBMRUniteReleve2.IBMREclairement.Eclaire" required>
                                    <mat-option *ngFor="let p of RecouvrementList; let i = index" [value]="i">
                                        <span>{{p}}</span>
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-6">
                            <mat-form-field class="w-100">
                                <mat-label>Tres Eclaire</mat-label>
                                <mat-select placeholder="Tres Eclaire" [(ngModel)]="IBMRProcess.IBMRUniteReleve2.IBMREclairement.TresEclaire" required>
                                    <mat-option *ngFor="let p of RecouvrementList; let i = index" [value]="i">
                                        <span>{{p}}</span>
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row" *ngIf="!ValidateEclairementClasses(IBMRProcess.IBMRUniteReleve2)">
                        <div class="col text-center">
                            <span style="color: red;">100% doit être absolument compris dans l'intervalle de la somme des classes</span>
                        </div>
                    </div>

                </div>
            </div>

            <div *ngIf="IBMRProcess.HasUR2" class="col-12 col-xl-6 my-1">
                <div class="border rounded-1 background-light p-3">
                    <!-- <h5 class="card-header">Vitesse Courant (m/s)</h5> -->
                    <div class="row">
                        <h2 class="col text-center fw-bold"> Vitesse Courant (m/s)</h2>
                    </div>
                    <div class="row">
                        <div class="col-6">
                            <mat-form-field class="w-100">
                                <mat-label>Inférieur à 0,05</mat-label>
                                <mat-select placeholder="Inférieur à 0,05" [(ngModel)]="IBMRProcess.IBMRUniteReleve2.IBMRVitesseCourant.VInferieur005"
                                            required>
                                    <mat-option *ngFor="let p of RecouvrementList; let i = index" [value]="i">
                                        <span>{{p}}</span>
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                        <div class="col-6">
                            <mat-form-field class="w-100">
                                <mat-label>Entre 0,05 et 0,2</mat-label>
                                <mat-select placeholder="Entre 0,05 et 0,2" [(ngModel)]="IBMRProcess.IBMRUniteReleve2.IBMRVitesseCourant.VEntre005Et02"
                                            required>
                                    <mat-option *ngFor="let p of RecouvrementList; let i = index" [value]="i">
                                        <span>{{p}}</span>
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-6">
                            <mat-form-field class="w-100">
                                <mat-label>Entre 0,2 et 0,5</mat-label>
                                <mat-select placeholder="Entre 0,2 et 0,5" [(ngModel)]="IBMRProcess.IBMRUniteReleve2.IBMRVitesseCourant.VEntre02Et05"
                                            required>
                                    <mat-option *ngFor="let p of RecouvrementList; let i = index" [value]="i">
                                        <span>{{p}}</span>
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                        <div class="col-6">
                            <mat-form-field class="w-100">
                                <mat-label>Entre 0,5 et 1</mat-label>
                                <mat-select placeholder="Entre 0,5 et 1" [(ngModel)]="IBMRProcess.IBMRUniteReleve2.IBMRVitesseCourant.VEntre05Et1"
                                            required>
                                    <mat-option *ngFor="let p of RecouvrementList; let i = index" [value]="i">
                                        <span>{{p}}</span>
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-6">
                            <mat-form-field class="w-100">
                                <mat-label>Supérieur à 1</mat-label>
                                <mat-select placeholder="Supérieur à 1" [(ngModel)]="IBMRProcess.IBMRUniteReleve2.IBMRVitesseCourant.VSuperieur1" required>
                                    <mat-option *ngFor="let p of RecouvrementList; let i = index" [value]="i">
                                        <span>{{p}}</span>
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row" *ngIf="!ValidateVitesseCourantClasses(IBMRProcess.IBMRUniteReleve2)">
                        <div class="col text-center">
                            <span style="color: red;">100% doit être absolument compris dans l'intervalle de la somme des classes</span>
                        </div>
                    </div>

                </div>
            </div>

            <div *ngIf="IBMRProcess.HasUR2" class="col-12 col-xl-6 my-1">
                <div class="border rounded-1 background-light p-3">
                    <!-- <h5 class="card-header">Végétation Aquatique</h5> -->
                    <div class="row">
                        <h2 class="col text-center fw-bold"> Végétation Aquatique</h2>
                    </div>
                    <div class="row">
                        <div class="col-12">
                            <mat-form-field class="w-100">
                                <mat-label>Surface Vegetalisee</mat-label>
                                <input matInput placeholder="Surface Vegetalisee" type="number" [(ngModel)]="IBMRProcess.IBMRUniteReleve2.SurfaceVegetalisee">
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-6">
                            <mat-form-field class="w-100">
                                <mat-label>Heterotrophes</mat-label>
                                <input matInput placeholder="Heterotrophes" type="number"
                                       [(ngModel)]="IBMRProcess.IBMRUniteReleve2.IBMRVegetationAquatique.Heterotrophes">
                            </mat-form-field>
                        </div>
                        <div class="col-6">
                            <mat-form-field class="w-100">
                                <mat-label>Algues</mat-label>
                                <input matInput placeholder="Algues" type="number"
                                       [(ngModel)]="IBMRProcess.IBMRUniteReleve2.IBMRVegetationAquatique.Algues">
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-6">
                            <mat-form-field class="w-100">
                                <mat-label>Bryophytes</mat-label>
                                <input matInput placeholder="Bryophytes" type="number"
                                       [(ngModel)]="IBMRProcess.IBMRUniteReleve2.IBMRVegetationAquatique.Bryophytes">
                            </mat-form-field>
                        </div>
                        <div class="col-6">
                            <mat-form-field class="w-100">
                                <mat-label>Pteridophytes</mat-label>
                                <input matInput placeholder="Pteridophytes" type="number"
                                       [(ngModel)]="IBMRProcess.IBMRUniteReleve2.IBMRVegetationAquatique.Pteridophytes">
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-6">
                            <mat-form-field class="w-100">
                                <mat-label>Phanerogames</mat-label>
                                <input matInput placeholder="Phanerogames" type="number"
                                       [(ngModel)]="IBMRProcess.IBMRUniteReleve2.IBMRVegetationAquatique.Phanerogames">
                            </mat-form-field>
                        </div>
                        <div class="col-6">
                            <mat-form-field class="w-100">
                                <mat-label>Hydrophytes Flottants</mat-label>
                                <input matInput placeholder="Hydrophytes Flottants" type="number"
                                       [(ngModel)]="IBMRProcess.IBMRUniteReleve2.IBMRVegetationAquatique.HydrophytesFlottants">
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-6">
                            <mat-form-field class="w-100">
                                <mat-label>Hydrophytes Immerges</mat-label>
                                <input matInput placeholder="Hydrophytes Immerges" type="number"
                                       [(ngModel)]="IBMRProcess.IBMRUniteReleve2.IBMRVegetationAquatique.HydrophytesImmerges">
                            </mat-form-field>
                        </div>
                        <div class="col-6">
                            <mat-form-field class="w-100">
                                <mat-label>Helophytes</mat-label>
                                <input matInput placeholder="Helophytes" type="number"
                                       [(ngModel)]="IBMRProcess.IBMRUniteReleve2.IBMRVegetationAquatique.Helophytes">
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row" *ngIf="!ValidateVegationEquality(IBMRProcess.IBMRUniteReleve2.IBMRVegetationAquatique)">
                        <div class="col text-center">
                            <span style="color: orange;">Heterotrophes + Algues + Bryophytes + Pteridophytes + Phanerogames doit être égal à HydrophytesFlottants + HydrophytesImmerges +
                                Helophytes</span>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>